import type { WeatherData } from 'owa-graph-schema';
import WeatherLocation from 'owa-service/lib/contract/WeatherLocation';
import convertOwsWeatherLocationIdToGqlWeatherLocation from './convertOwsWeatherLocationIdToGqlWeatherLocation';

export default function convertOwsWeatherLocationToGqlWeatherData(
    owsWeatherLocation: WeatherLocation
): WeatherData {
    const { Conditions, MultidayForecast } = owsWeatherLocation;

    const gqlWeatherData: WeatherData = {
        locationId: convertOwsWeatherLocationIdToGqlWeatherLocation(owsWeatherLocation.Id),
        conditions: {
            attribution: {
                text: Conditions?.Attribution?.Text,
                link: Conditions?.Attribution?.Link,
            },
            temperature: Conditions?.Temperature,
            skyCode: Conditions?.SkyCode,
            skyText: Conditions?.SkyText,
        },
        multidayForecast: {
            attribution: {
                text: MultidayForecast?.Attribution?.Text,
                link: MultidayForecast?.Attribution?.Link,
            },
            dailyForecasts: MultidayForecast?.DailyForecasts?.map(dailyConditions => {
                return {
                    high: dailyConditions.High,
                    low: dailyConditions.Low,
                    skyCode: dailyConditions.SkyCode,
                    skyText: dailyConditions.SkyText,
                    precipitationChance: dailyConditions.PrecipitationChance,
                };
            }),
        },
        clickThrough: owsWeatherLocation.ClickThrough,
    };

    return gqlWeatherData;
}
